export default __webpack_public_path__ + "static/media/resposta_certa_01.4b3566d4.mp3";